import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Button, Checkbox, Table, TableBody, TableCell, TableRow} from '@material-ui/core';
import {Paper, Menu, MenuItem, IconButton} from '@material-ui/core';

import { CheckBox, MoreVert } from '@material-ui/icons';
import { Switch } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import { decimalColorToHexColor } from '../../../../api/helpers';

class KmlListEditor_ extends React.Component {


    constructor(props){
        super(props)

        this.state = {menuAnchor: null, menuData: null}

        this.handleInput = this.handleInput.bind(this)
    }

    handleMenuClick(event, kmlayer){
        this.setState({menuAnchor: event.currentTarget, menuData: kmlayer});
        event.stopPropagation();
    }

    handleMenuClose(){
        //this.menuAnchor = null;
        this.setState({menuAnchor: null, menuData: null});
        return null;
    }

    handleMenuItemClick(menu){
        const kmlayer = this.state.menuData
        this.handleMenuClose();
        this.props.onContextMenu(menu, kmlayer)
    }

    handleSelect(ID){
        this.props.onSelect(ID)
    }

    getItemStyle(ID){
        let selected = ID === this.props.selectedID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleInput(event, ID){
        const changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value 
        
        this.props.onAction({type:'KML_LAYER_SET_PROPERTY', id: ID, name: event.target.name, value: val })
    }

    render(){
            const {t, kmlLayers} = this.props
    
            //this.props.users.sort(sortByOnlineName)
    
            const styles = {
                paper: {
                  width: '100%',
                  overflowX: 'auto',
                },
                head: {
                    color: theme.palette.color.dialogTitle,
                    backgroundColor: theme.palette.background.dialogTitle,
                }
            };
    
            /*
            const users = this.props.users.map((user)=>{
                user.StatusName = null
                user.StatusColor = null
                if(user.StatusID!==undefined){
                    const statusIndex = getIndexByID(user.StatusID, this.props.statuses)
                    if(statusIndex!==null){
                        const status = this.props.statuses[statusIndex]
                        user.StatusName = status.Name
                        user.StatusColor = decimalColorToHexColor(status.Color) 
                    }
                }
                return user
            })
            */
    
            return(
                <>
                    <Paper style={styles.paper}>
                        <Table size="small">
                            <TableBody>
                            {kmlLayers.map((kmlayer) => 
                                <TableRow key={kmlayer.ID} 
                                        onClick={()=>{this.handleSelect(kmlayer.ID)}}
                                        onDoubleClick={()=>{this.handleMenuItemClick('properties', kmlayer.ID)}}
                                        style={this.getItemStyle(kmlayer.ID)}>
                                    <TableCell style={{width:40, position:'relative'}} >
                                        <Checkbox
                                            style={{color: decimalColorToHexColor(kmlayer.Color) }}
                                            checked={Boolean(kmlayer.ShowOnMap)} 
                                            title="ShowOnMap"
                                            name="ShowOnMap"
                                            onChange={(event)=>{this.handleInput(event, kmlayer.ID )}}/>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {kmlayer.Name}
                                    </TableCell>

                                    <TableCell style={{width:30}}>
                                        <IconButton size="small" color="inherit" aria-label="more" 
                                            component="span" title={t('DrawOnMap')}
                                            onClick={event=>this.handleMenuClick(event, kmlayer)}>
                                            <MoreVert />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                            <Menu anchorEl={this.state.menuAnchor} keepMounted
                                open={Boolean(this.state.menuAnchor)} 
                                onClose={this.handleMenuClose.bind(this)}>
    
                                <MenuItem onClick={()=>{this.handleMenuItemClick('PROPERTIES')}}>{t('Properties')}</MenuItem>
                                <MenuItem onClick={()=>{this.handleMenuItemClick('DELETE')}}>{t('Delete')}</MenuItem>
                            </Menu>
                        </Table>
                    </Paper>
                </>
            )
    
        }


}



export const KmlListEditor = withTranslation()(KmlListEditor_);